import React, { FC } from 'react';
import { TaskDependencyStatusChanged } from 'api/notifications/meta';
import { StatusGroup, TaskType } from 'api/tasks';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { getTaskStatusField } from 'utils/get-task-status-field';
import { DependencyChangedMessage } from './dependency-changed-message';
import { getStatusValue } from './utils';

export const TaskDependencyStatusChangedView: FC<{
  meta: TaskDependencyStatusChanged;
  type: TaskType;
}> = ({ meta: { by, association, externalUser }, type }) => {
  const statusField = getTaskStatusField(association?.fields);
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);

  if (!association || !statusField) {
    return null;
  }

  const to = {
    group: statusField.fieldValue as StatusGroup,
    label: statusField.metaFieldValue?.label,
  };

  return (
    <DependencyChangedMessage
      by={userDetails}
      to={getStatusValue(type, to)}
      task={association}
    />
  );
};
